<template>
	<div class="company-advanced-card-edit" :value="value">
		<span class="company-advanced-card__item">
			<Input label="Company Name" v-model="localData.companyName" />
		</span>
		<span class="company-advanced-card__item">
			<Input
				label="Company Nickname"
				v-model="localData.companyNickname"
			/>
		</span>
		<span class="company-advanced-card__item">
			<Input label="Dominion ID #" v-model="localData.dominionID" />
		</span>
		<span class="company-advanced-card__item">
			<Input
				label="Dealer Client #"
				v-model="localData.dealerCustomer"
			/>
		</span>
		<span class="company-advanced-card__item">
			<Input label="Company Code" v-model="localData.companyCode" />
		</span>
		<span class="company-advanced-card__item">
			<DatePicker
				label="Go Live Data"
				datePickerType="singleDate"
				v-model="goLiveDate"
			/>
		</span>
		<span class="company-advanced-card__item">
			<ColorPicker
				label="Company Color"
				v-model="localData.companyColor"
			/>
		</span>
		<span class="company-advanced-card__item">
			<Toggle label="Active" v-model="status" />
		</span>
		<span class="company-advanced-card__item">
			<label for="auditLogOn">Audit Log On</label>
			<Toggle
				id="auditLogOn"
				v-model="localData.auditLogOn"
				:isLabelBefore="true"
			>
				<template slot="true-value">YES</template>
				<template slot="false-value">NO</template>
			</Toggle>
		</span>
		<span class="company-advanced-card__item">
			<!-- To use when component is fixed -->
			<!-- <DropdownMultiselect
				label="Company Group"
				v-model="companyGroups"
				:options="companyGroupsOptions"
				:defaultValue="'Multiselect Placeholder'"
			/> -->
		</span>
	</div>
</template>

<script>
import Input from '@/components/forms/input/input';
import DatePicker from '@/components/forms/date-picker/date-picker';
import Toggle from '@/components/forms/selection-control/toggle/toggle';
import ColorPicker from '@/components/forms/color-picker/color-picker';
// import DropdownMultiselect from '@/components/forms/dropdown/dropdown-multiselect.vue';
import _ from 'lodash';

export default {
	name: 'CompanyAdvancedCardEdit',
	components: { Input, DatePicker, Toggle, ColorPicker },
	props: {
		value: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			localData: _.cloneDeep(this.value),
			goLiveDate: null,
			status: false,
			companyGroups: [],
			companyGroupsOptions: [
				{
					text: 'Jeep Holdings',
					value: 'Jeep Holdings',
					selected: false
				},
				{
					text: 'Lorem Ipsum',
					value: 'Lorem Ipsum',
					selected: false
				}
			]
		};
	},
	created() {
		// console.log('value: ', this.value);
		this.companyGroups = [...this.localData.companyGroups];
		this.goLiveDate = new Date(this.localData.liveDate);
		this.status = !this.localData.inactive;
	},
	methods: {
		emitNewValues() {
			this.localData.liveDate = this.goLiveDate.toLocaleDateString();
			this.localData.inactive = !this.status;
			this.$emit('update', this.localData);
			this.$emit('input', this.localData);
		}
	},
	watch: {
		localData: {
			deep: true,
			handler() {
				this.emitNewValues();
			}
		},
		status() {
			this.emitNewValues();
		},
		goLiveDate() {
			this.emitNewValues();
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/scss/5-objects/_cards.scss';

.company-advanced-card-edit {
	@include card;

	&__item {
		display: block;
	}
}
</style>
